import { CurrencyCode, ICurrency } from 'meta/currency'

export const initialState: ICurrency = {
  activeCurrency: CurrencyCode.NONE,
}
